export var emptyString = '';
export var emptyArray = [];
export var emptyObject = {};